import { createContext, useContext, useEffect, useState } from "react";
import { copy } from "../data/content";

const LanguageContext = createContext(undefined);

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const getInitialLang = () => {
  if (typeof window !== "undefined") {
    const saved = window.localStorage.getItem("lang");
    if (saved === "DE" || saved === "EN") return saved;
  }
  if (typeof navigator !== "undefined" && navigator.language) {
    return navigator.language.toLowerCase().startsWith("de") ? "DE" : "EN";
  }
  return "DE";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    document.documentElement.lang = lang.toLowerCase();
    if (typeof window !== "undefined") window.localStorage.setItem("lang", lang);

    // Keep <title> and Open Graph / Twitter meta in sync with the active language
    const title = copy.meta.title[lang];
    const description = copy.meta.description[lang];
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[property="og:locale"]', "content", lang === "DE" ? "de_AT" : "en_US");
  }, [lang]);

  const toggle = () => setLang((prev) => (prev === "DE" ? "EN" : "DE"));

  // helper: resolves { DE, EN } objects to the active language
  const t = (value) =>
    value && typeof value === "object" && "DE" in value ? value[lang] : value;

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
